// extracted by mini-css-extract-plugin
module.exports = {"services":"services-module--services--yI-1W","center":"services-module--center--3Pnbr","service":"services-module--service--2-1dB","links":"services-module--links--2hZtG"};